import { render, staticRenderFns } from "./BaseItemClassification.vue?vue&type=template&id=cad9113c&scoped=true&"
import script from "./BaseItemClassification.vue?vue&type=script&lang=js&"
export * from "./BaseItemClassification.vue?vue&type=script&lang=js&"
import style0 from "./BaseItemClassification.vue?vue&type=style&index=0&id=cad9113c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad9113c",
  null
  
)

export default component.exports